<template>
  <div>
    <common-dialog
      ref="dialog"
      width="600px"
      unit="提现审核"
      id-key="RecordId"
      
    >
      <template slot="form">
        <el-row>
          
          <el-col :span="isMB?24:12">
            <el-form-item label="会员姓名" prop="">
                李东海
            </el-form-item>
          </el-col>

           
          <el-col :span="isMB?24:12">
            <el-form-item label="提现金额" prop="">
                80
            </el-form-item>
          </el-col>

          <el-col :span="isMB?24:12">
            <el-form-item label="申请时间" prop="">
                2024-03-13 10:01:12
            </el-form-item>
          </el-col>
          
           <el-col :span="isMB?24:12">
            <el-form-item label="状态" prop="">
               待审核
            </el-form-item>
          </el-col>
         
        </el-row>
       
      </template>
      <template slot="footer">
        <template>
          <template>
            <el-button type="success" @click="pass">通 过</el-button>
            <el-button type="danger" @click="noPass">不通过</el-button>
          </template>
         
        </template>
        <el-button @click="close">关闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>

import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import singlePicUpload from "@/components/common/photo/singleUpload";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    singlePicUpload,
  },
  computed: {
    host() {
      return window.location.origin;
    }
  },
  data() {
    return {
      data: {
       
      },
     
    };
  },
  methods: {
   
  }
};
</script>
<style lang="scss">
.file-text2{
  .el-upload--text {
    display: none;
  }
  .el-upload-list__item-name {
    margin-top: -8px;
  }
}
</style>